import BaseType from "../BaseType";

export default class EmailLocalization extends BaseType {
  EmailId: string = "";
  Locale: string = "";
  Subject: string = "";
  Body: string = "";
}
